module.exports = __webpack_public_path__ + "img/info_dash.ad1bde8d.svg";